<template>
  <!-- {{forms}} -->
  <div class="custom-form" v-if="forms && form_elements">
    <Form ref="form" @fsubmit="submit($event)" class="form-body" @mounted="formMounted()">
      <DataPlaceholder v-if="awaiting_submission"/>
      <div :style="{'display': awaiting_submission?'none':'block'}">
        <component @change="handleInputChange($event,element.id)" :readonly="element.data.permission && element.data.permission>forms[$route.params.form_id][0].permission" :ref="`${element.id}`" font_size="1.1rem" v-for="element in order(form_elements[$route.params.form_id])" :key="element" :name="`${element.id}`" :is="element.component" v-bind="element.data"/>
        <Button name="submit" :label="button_lable" ref="submit" :loading="awaiting_submit"/>
      </div>

      <div class="submission-owner" :style="{'display': forms[$route.params.form_id][0].permission>=4 ? 'block' : 'none'}">
        <Radio ref="owner_type" name="owner_type" :preset="owner_type" @change="handleOwnerTypeChange($event)" label="Select owner type" :options="owner_type_options"/>
        <SelectAsyncElement name="owner"  @mounted="setOwner" label="Submission Owner" :url="data_url" :data_name="data_name" :required="false" ref="owner" :getOptionName="userSelectCast"/>
      </div>
      <div class="submission-status" v-if="forms[$route.params.form_id][0].permission>=3 && forms[$route.params.form_id][0].state_options">
        <Radio :readonly="true" ref="status" :preset="0" name="status" label="Submission Status" :options="forms[$route.params.form_id][0].state_options.options"/>
      </div>
    </Form>
  
    <div class="replies" v-if="$route.params.submission_id">
      <h2>List of replies</h2>
      <Reply v-for="reply in replies" :key="reply" :reply="reply"/>
    </div>
    <h2 v-if="$route.params.submission_id">Reply to Submission</h2>
    <Form ref="reply_form" @fsubmit="reply($event)" @mounted="$refs.reply_form.refs=$refs" v-if="$route.params.submission_id">
      <div class="reply-body">
        <InputElement name="reply_subject" label="Subject" :required="true"/>
        <label for="reply_content" class="reply-content-label">Content</label>
        <textarea name="reply_content" rows="10" class="reply-content" ref="reply_body"/>
        <FileUploadElement label="Attachment" name="reply_attachment"/>
        <Checkbox :label="`Also send email with contents of the reply to the submission owner / members of: ${submission?.owner.name}`" :presetValue="false" name="send_mail"/>
        <Button name="submit_reply" label="Send Reply" ref="submit" :loading="awaiting_reply"/>
      </div>

    </Form>
  </div>
</template>

<script>
import Form from '@/components/form/Form.vue'
import InputElement from '@/components/inputs_23/InputElement.vue'
import SelectElement from '@/components/inputs_23/SelectElement.vue'
import SelectReferenceElement from '@/components/inputs_23/SelectReferenceElement.vue'
import SelectAsyncElement from '@/components/inputs_23/SelectAsyncElement.vue'
import Checkbox from '@/components/inputs_23/Checkbox.vue'
import FileUploadElement from '@/components/inputs_23/FileUploadSingle.vue'
import HeaderElement from '@/components/inputs/HeaderElement.vue'
import LinkElement from '@/components/inputs/LinkElement.vue'
import Textarea from '@/components/inputs/Textarea.vue'
import SectionElement from '@/components/inputs/SectionElement.vue'
import Button from '@/components/inputs_23/Button.vue'
import Radio from '@/components/inputs_23/Radio.vue'
import axios from "axios";
import Reply from '@/components/forms/submission/Reply.vue'
import DataPlaceholder from '@/components/DataPlaceholder.vue' 
export default {
  name: 'CustomForm',
  components: {
    LinkElement,
    DataPlaceholder,
    Form,
    InputElement,
    SelectElement,
    Button,
    Checkbox,
    FileUploadElement,
    HeaderElement,
    SectionElement,
    SelectReferenceElement,
    SelectAsyncElement,
    Radio,
    Textarea,
    Reply,
  },
  props: {
    forms: Object,
    form_elements: Object,
    organization: Object,
  },
  data() {
    return {
      awaiting_submit: false,
      awaiting_submission: false,
      awaiting_reply: false,
      users: [],
      owners_loading: false,
      owner_type: 0,
      submission: null,
      replies: null,
    }
  },
  mounted() {
    if(this.organization) {
      this.owner_type = 1
    }
  },
  watch: {
    $route(to,from) {
      if(to.params.submission_id && to.params.submission_id!==from.params.submission_id) {
        this.getPresetSubmission(to.params.form_id,to.params.submission_id)
      }
      if(!to.params.submission_id) {
        this.$refs.form.clear()
        this.setOwner()
      }
    }
  },
  computed: {
    owner_type_options() {
      if(!this.organization) {
        return [{id:0,label:'User'},{id:1,label:'Group'}]
      }
      return [{id:1,label:'Group'}]
    },
    data_name() {
      if(this.owner_type==0) {
        return "users"
      }
      if(this.owner_type==1) {
        return "groups"
      }
      return null
    },
    data_url() {
      if(this.owner_type==0) {
        return this.$store.getters.getApiUrl+"users"
      }
      if(this.owner_type==1) {
        return this.$store.getters.getApiUrl+"groups"
      }
      return null
    },
    button_lable() {
      if(this.$route.params.submission_id>=0) {
        return 'Update'
      }
      return 'Submit'
    },
  },
  methods: {
    handleInputChange(data,element_id) {
      if(this.forms[this.$route.params.form_id][0].state_options?.type==='sync' && this.forms[this.$route.params.form_id][0].permission>=3 && element_id===this.forms[this.$route.params.form_id][0].state_options.el_id) {
        console.log(data,element_id)
        this.$refs.status?.setValue(data)
      }
    },
    async reply(formData) {
      const request_header = {method:'post',url:this.$store.getters.getApiUrl+`reply/${this.$route.params.submission_id}`,data:formData}
      this.awaiting_reply = true
      // formData.append("submission_id", this.$route.params.submission_id)
      const {data,error} = await axios(request_header).catch(error=>{return {data:null, error}})
      console.log(data,error?.response)
      this.awaiting_reply = false
    },
    handleOwnerTypeChange(value) {
      this.owner_type = value
      this.$refs.owner.clear()
    },
    userSelectCast(user,html=false) {
      if(html) {
        return `<span style="font-weight:bold;">ID: </span>${user.id}, <span style="font-weight:bold;">Name: </span>${user.name}`
      }
      return [user.id,user.name].join(', ')
    },
    async setOwner() {
      if(this.$route.params.submission_id) {
        return
      }
      if(this.organization) {
        this.owner_type = 1
        await this.$nextTick()
        this.$refs.owner?.setValue(this.organization.id)
        return
      }
      if(!this.$store.getters.getProfile) {
        return
      }
      this.owner_type = 0
      await this.$nextTick()
      this.$refs.owner?.setValue(this.$store.getters.getProfile.id)
    },
    formMounted() {
      this.$refs.form.refs=this.$refs
      if(this.$route.params.submission_id) {
        this.getPresetSubmission(this.$route.params.form_id,this.$route.params.submission_id)
      }
    },
    async getPresetSubmission(form_id,submission_id) {
      const request_header = {method:'get',url:this.$store.getters.getApiUrl+`__submissions__/${form_id}/${submission_id}`}
      const params = {}
      params.key='jd(3.3329djHaiJK3023ld0OD=3'
      request_header.params = params
      this.awaiting_submission = true
      const {data,error} = await axios(request_header).catch(error=>{return {data:null, error}})
      this.awaiting_submission = false
      if(error) {
        console.log(error?.response)
      }
      this.submission = data.submission
      this.replies = data.replies
      if(data.replies && data.replies.length>0) {
        this.$store.dispatch('__clear__')
      }
      console.log(data)
      this.owner_type = data?.submission?.owner_type=='App\\Models\\User' ? 0 : 1
      this.$refs.owner_type?.setValue(this.owner_type)
      await this.$nextTick()
      this.$refs.owner?.setValue(data.submission.owner.id)
      this.form_elements[this.$route.params.form_id].forEach(el=>{
        if(this.$refs[`${el.id}`]?.setValue) {
          this.$refs[`${el.id}`]?.setValue(data.submission._data[`${el.id}`])
        }
      })
    },
    order(elements) {
      return elements?.sort((a,b)=>{
        if(a.position>=b.position) {
          return 1
        }
        return -1
      })
    },
    async submit(form_data) {
      console.log(this.$refs.owner.value, 'check')
      const request_header = {method:'post',url:this.$store.getters.getApiUrl+`__submissions__/${this.$route.params.form_id}`,data:form_data}
      // const request_header = {method:'post',url:this.$store.getters.getApiUrl+`_forms/${this.$route.params.form_id}/submissions`,data:form_data}
      if(this.$route.params.submission_id) {
        request_header.url += `/${this.$route.params.submission_id}`
      }
      const params = {}
      params.key='jd(3.3329djHaiJK3023ld0OD=3'
      request_header.params = params
      this.awaiting_submit = true
      const {data,error} = await axios(request_header).catch(error=>{return {data:null, error}})
      this.awaiting_submit = false
      if(error) {
        console.log(error?.response)
        this.$refs.submit.animate_error = true
        if(error.response.data.message) {
          this.$refs.submit.error_message = error.response.data.message
        }
        return
      }
      console.log(data)
      this.$refs.submit.success = true
      this.$store.dispatch('__clear__')
      this.$router.push({query:{...this.$route.query,highlight: data.id}})
    }
  }

}
</script>


<style scoped lang="scss">
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.reply-content-label,.reply-content {
  width: 100%;
}
.replies {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
.reply-body {
  background-color: white;
  // margin: 1rem 0;
  border: 1px solid black;
  border-radius: 8px;
  padding: 3rem;
  width: 210mm;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.custom-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .form-body {
    background-color: white;
    // margin: 1rem 0;
    border: 1px solid black;
    border-radius: 8px;
    padding: 3rem;
    width: 210mm;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
